import { styled } from "@mui/system";

export const Button = styled('button')({
    color: '#021A1A',
    textAlign: 'center',
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: 'normal',
    borderRadius: '24px',
    backgroundColor: '#00E378',
    padding: '4px 14px',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'Poppins',
    transition: 'background-color 0.3s ease',

    '&:hover': {
        backgroundColor: '#00C467',
        transition: 'background-color 0.3s ease',
    },
    '@media (max-width: 1024px)': {
        fontSize: '10px',
        padding: '3px 12px',
    }
})
